<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table v-model="selected" :items="items" :headers="headers">
          <template v-slot:no-data>
            <h3>No data available</h3>
          </template>
        </v-data-table>
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
import { api } from "@/plugins/api";
// import repo from "@/store/repo.js";
// import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
//import { resolvePlugin } from "@babel/core";

//import * as XLSX from "xlsx";

export default {
  components: {
    OverlayLoader,
  },
  data: () => ({
    balance_limit: 15000,
    headers: [
      { title: "الاسم", key: "meter" },
      { title: "الاستهلاك", key: "consumation" },
      { title: "استهلاك الأبناء", key: "children_consumation" },
    ],
    loading: false,
    dialog: false,
    response: [],
  }),
  computed: {
    items() {
      return this.response;
    },
  },

  methods: {
    async fetch() {
      this.loading = true;
      const resp = await api.get("/stats/report");
      //console.log("data", resp.data.data);
      this.response = resp.data.data;
      //this.response = Array.isArray(resolvePlugin.data) ? resp.data : []; // Ensure response is an array
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
